import axios from "axios";
import { saveAs } from "file-saver";
import { PROYECT } from "services/api";
import { getErrorBlob } from "helpers/extractError";
import { setSnackbar, startRequestComp, stopRequestComp } from "redux/actions/search/searchActions";
import {
  PROGRESSIVE_APP_REPORT_LOADINGS,
  reportProgressiveAppTypes,
} from "redux/reducers/Reports/reportProgressiveApp/types";

const { SET_PROGRESSIVE_APP_REPORT_FILTERS } = reportProgressiveAppTypes;
const { GET_REPORT } = PROGRESSIVE_APP_REPORT_LOADINGS;

export const getReportProgressiveAppAction = (
  { startDate, endDate, station, isPdf }
) => async (dispatch, getState) => {
  const token = getState().login.token || localStorage.getItem('crm-user');
  const params = {
    idStation: station.id,
    start: startDate,
    end: endDate,
    pdf: isPdf,
  };
  dispatch(startRequestComp(GET_REPORT));
  try {
    const url = `${process.env.REACT_APP_URL}${PROYECT}/reports/progressive-app`;
    const res = await axios.get(url, {
      headers: { authorization: token },
      responseType: "blob",
      params,
    });

    const format = isPdf ? "pdf" : "xlsx";
    saveAs(res.data, `Reporte_app_progresivo_${station.name}_${startDate}_${endDate}.${format}`);
    dispatch(setSnackbar("Reporte descargado con éxito", "success"));
  } catch (err) {
    dispatch(setSnackbar(await getErrorBlob(err)));
  } finally {
    dispatch(stopRequestComp(GET_REPORT));
  }
};

export const setReportProgressiveAppFilters = (key = "", value) => ({
  type: SET_PROGRESSIVE_APP_REPORT_FILTERS,
  payload: { key, value }
});
